import TaxCouponTable from './TaxCouponTable'

export default TaxCouponTable
